/**
 * Enum para identificar los tipos de documentos del módulo Supply Warehouse
 * Usado para determinar qué proceso ejecutar en el componente de detalle
 */
export enum SupplyWarehouseDocumentType {
  /**
   * Goods Receipt Note (GRN) - Recepción de mercancías
   * Iniciado desde Purchase Order
   */
  GoodsReceiptNote = 'GRN',

  /**
   * Dispatch Request (DR) - Solicitud de despacho
   * Iniciado desde Supply Request o Internal Requisition
   */
  DispatchRequest = 'DR',

  /**
   * Material Issue (MI) - Emisión de material
   * Iniciado desde Dispatch Request o Internal Requisition
   */
  MaterialIssue = 'MI',

  /**
   * Internal Return (IR) - Devolución interna
   * Iniciado desde Dispatch Request
   */
  InternalReturn = 'IR',

  /**
   * Provider Return (PR) - Devolución a proveedor
   * Iniciado desde Goods Receipt Note
   */
  ProviderReturn = 'PR',
}
